import { ComparatorContext, IProduct } from '@kizi/comparator-core';
import { Div, P } from '@kizi/core-components';
import { IconV2, IconV2Props, Table } from '@kizi/shared-components';
import React, { useContext } from 'react';
import { ProductLogo } from '../../..';
import { CbLogo } from '../../../../CbLogo';
import { OsLogo } from '../../../../OsLogo';

const DefaultIcon: React.FC<IconV2Props> = (props) => (
  <IconV2 height={28} width="auto" {...props} />
);

const greenCheckIcon = <DefaultIcon name="green-check" />;
const minusIcon = <DefaultIcon name="minus" />;

interface SwitchTabProps {
  data: IProduct;
}

export const SwitchTabHome: React.FC<SwitchTabProps> = ({ data }) => {
  const { image, provider, type } = data;
  const { taskDivisions, name: providerName } = provider;

  const { name } = useContext(ComparatorContext);
  const isOverstappen =
    name.includes('os-') || name === 'moneysure-event-based';

  if (!Array.isArray(taskDivisions)) return null;

  let mainDescription = '';
  if (['home', 'os-home', 'os-travel', 'travel', 'savings'].includes(type)) {
    mainDescription = `Benieuwd wat ${providerName} doet en wat wij doen? Lees het hieronder.`;
  } else {
    for (let task of taskDivisions) {
      if (task.name === 'Task-division-who') {
        mainDescription = task.value;
        break;
      }
    }
  }

  function getDescription(taskDivisionName) {
    switch (taskDivisionName) {
      case 'Task-division-who':
        return null;
      case 'Task-division-compare':
        return 'Vergelijken en aanvragen';
      case 'Task-division-documents':
        return 'Documenten sturen';
      case 'Task-division-request':
        return 'Hulp bij vragen';
      case 'Task-division-data':
        return 'Gegevens wijzigen';
      case 'Task-division-damage':
        return 'Schade afhandelen';
      case 'Task-division-collect':
        return 'Premie incasseren';
      default:
        return null;
    }
  }

  function getClientIcon(clientValue) {
    return clientValue === 'true' ? greenCheckIcon : minusIcon;
  }

  function getSupplierIcon(supplierValue) {
    return supplierValue === 'true' ? minusIcon : greenCheckIcon;
  }

  return (
    <Div>
      <P mb={3} variant="bodyImportant">
        Wie doet wat?
      </P>
      <P variant="footnoteRegular" mb={3}>
        {mainDescription}
      </P>
      <Table
        rows={[
          [
            '',
            isOverstappen ? (
              <OsLogo key="logo-big" height={20} />
            ) : (
              <CbLogo key="logo-big" height={20} />
            ),
            <ProductLogo
              key="logo-provider"
              image={image}
              width={'50%'}
              margin={'auto'}
            />,
          ],
          ...taskDivisions
            .filter((task) => getDescription(task.name) !== null)
            .map((task) => {
              return [
                getDescription(task.name),
                getClientIcon(task.value),
                getSupplierIcon(task.value),
              ];
            }),
        ]}
        variant="comparison"
      />
    </Div>
  );
};
